exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-big[data-v-50a74aca]:hover{font-weight:700}.break-row[data-v-50a74aca]{-webkit-line-clamp:7}.break-row[data-v-50a74aca],.break-sys-note[data-v-50a74aca]{white-space:pre-wrap;word-wrap:break-word;overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical}.break-sys-note[data-v-50a74aca]{-webkit-line-clamp:2}", ""]);

// exports
